export default "__VITE_ASSET__BViNwlBw__"